import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-procedure-content-view-selector',
    templateUrl: './procedure-content-view-selector.component.html',
    styleUrls: ['./procedure-content-view-selector.component.scss'],
    standalone: false
})
export class ProcedureContentViewSelectorComponent {

  @Input() currentProcedureContentViewName: string;
  @Output() viewSelected = new EventEmitter<string>();

  selectView(viewName: string) {
    this.currentProcedureContentViewName = viewName;
    this.viewSelected.emit(viewName);
  }

}
